<template>
  <div id="emptyState" v-bind:class="`${viewStyle} ${viewSize}`">
    <div class="state-holder center">
      <i class="material-icons" v-if="iconType === 'icon_font'">
        {{dataIcon}}
      </i>
      <img v-else :src="dataIcon" alt="">
      <div class="header-title ">
        <slot name="header">Empty Message</slot>
      </div>
      <div class="message-content">
         <slot name="content">No Content for the desired block</slot>
      </div>
      <div class="center" v-if="showButton">
        <slot name="action"><button @click="$_emptyTrigger()" class="btn btn-medium blue blue-view waves-effect">Create </button></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name:'emptyState',
props:{
  showButton:{
    type:Boolean,
    default:false,
  },
  iconType:{
    type:String,
    default:'icont_font'
  },
  viewStyle:{
    type:String,
    default:'default'
  },
  viewSize:{
    type:String,
  },
  dataIcon:{
    type:String,
    default:'work_outline'
  },
},
methods:{
  $_emptyTrigger(){
    this.$emit('action', true)
  }
}
}
</script>

<style lang="scss" scoped>
#emptyState {
    width: 350px;
    height: 350px;
    margin: auto;
    border-radius: 50%;
    position: relative;
    margin-top: 36px;
    margin-bottom:36px;
    &.circleBg {
      padding: 40px 32px;
       background-color: rgba(0, 0, 0, 0.05);
        .state-holder {
          padding: 40px 32px;
        }
    }
  .state-holder {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
     img { width:200px; margin-bottom:24px;}
  }
  .header-title {
    font-size:22px;
    font-weight: 500;
    margin-bottom:8px;
    margin-top:-12px;
  }
  i {
    font-size: 9rem;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    line-height: 160px;
    margin: 0px;
    padding: 0px;
    height: 160px;
    }
    .message-content {
      margin-bottom: 24px;
      font-size: 16px;
      line-height: 21.5px;
    }
}

</style>
